import './config/startup';

import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
// import './utils/I18n';
// import './utils/Currencies';
import App from './components/App';
// import * as serviceWorker from './serviceWorker';

try {
	ReactDOM.render(<App />, document.getElementById('root'));

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: http://bit.ly/CRA-PWA
	// serviceWorker.unregister();
} catch (e) {
	// Sentry.captureException(e);
}
